import { ensureDeviceId, makeSendPurchaseEvent } from '@insify/ui-utils';
import TagManager from 'react-gtm-module';

import { isLocalDev, isProdOrStaging } from '../../util/env';

import type { SendPurchaseEventFn } from '@insify/ui-utils';
import type { DataLayerArgs } from 'react-gtm-module';

export enum GTMEvent {
  PROPERTY_AND_CASUALTY_PURCHASE = 'property-and-casualty-purchase',
  DAISYCON_PNC_PURCHASE = 'daisycon_pnc_purchase',
  DAISYCON_PNC_LEAD = 'daisycon_pnc_lead',
}

export const useTagManager = (): {
  dataLayerPush: (args: DataLayerArgs) => void;
  sendEvent: (event: GTMEvent | string, payload?: Record<string, string>) => void;
  sendPurchaseEvent: SendPurchaseEventFn<'fr-pnc'>;
} => {
  const deviceId = ensureDeviceId(isLocalDev ? undefined : '.insify.fr');

  const dataLayerPush = (args: DataLayerArgs): void => {
    if (!isProdOrStaging) return;
    TagManager.dataLayer(args);
  };

  const sendEvent = (event: GTMEvent | string, payload?: Record<string, string>): void => {
    const args: DataLayerArgs = {
      dataLayer: {
        event,
        trackingUserId: deviceId,
        ...payload,
      },
    };

    dataLayerPush(args);
  };

  return {
    dataLayerPush,
    sendEvent,
    sendPurchaseEvent: makeSendPurchaseEvent('fr-pnc', TagManager),
  };
};
